export { default } from "./CitationGeneratorBodyPanel";
